import _toConsumableArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import { getAerialComparisonApi } from '../api';
import { isDateAfterToday } from '@/utils/datetime';

import dayjs from 'dayjs';
import { mapState, mapActions } from 'vuex';
var CSV_HEADER = ['監控_INV_id', '監控_PV_id', '監控_絕緣阻值', '監控_PV電壓', '監控_PV電流', '監控_RA值'];
export default {
  name: 'AerialComparison',
  data: function data() {
    return {
      loadingData: false,
      searchInput: '',
      // 案場名稱_fId
      selectedDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
      // 預設昨日
      selectedTime: '',
      // 'HH:mm'
      previewData: [],
      downloadInfo: [] // [factoryName, date, time]
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState(['factoryInfo'])), {}, {
    filteredFactoryInfo: function filteredFactoryInfo() {
      return this.factoryInfo.filter(function (item) {
        return !item.isDemoSite;
      });
    }
  }),
  watch: {
    // 查詢條件一改，清空舊查詢結果，避免下載到與畫面不符的資料
    searchInput: 'resetResult',
    selectedDate: 'resetResult',
    selectedTime: 'resetResult'
  },
  methods: _objectSpread(_objectSpread({}, mapActions(['asyncInfo'])), {}, {
    isDateAfterToday: isDateAfterToday,
    showVal: function showVal(v) {
      return v === null || v === undefined ? '-' : v;
    },
    resetResult: function resetResult() {
      this.previewData = [];
      this.downloadInfo = [];
    },
    search: function search() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var factoryName, fId, _yield$getAerialCompa, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.searchInput) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", _this.$swal('請輸入案場'));
              case 2:
                if (_this.selectedDate) {
                  _context.next = 4;
                  break;
                }
                return _context.abrupt("return", _this.$swal('請選擇日期'));
              case 4:
                if (_this.selectedTime) {
                  _context.next = 6;
                  break;
                }
                return _context.abrupt("return", _this.$swal('請選擇時間'));
              case 6:
                factoryName = _this.searchInput.split('_')[0];
                fId = _this.searchInput.split('_')[1];
                if (fId) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return", _this.$swal('請選擇案場名稱(含編號)'));
              case 10:
                _this.loadingData = true;
                _context.prev = 11;
                _context.next = 14;
                return getAerialComparisonApi(factoryName, fId, _this.selectedDate, _this.selectedTime);
              case 14:
                _yield$getAerialCompa = _context.sent;
                data = _yield$getAerialCompa.data;
                if (data.success) {
                  _context.next = 18;
                  break;
                }
                return _context.abrupt("return", _this.$swal(data.msg || '查詢失敗'));
              case 18:
                if (!(!data.data || !data.data.length)) {
                  _context.next = 21;
                  break;
                }
                _this.previewData = [];
                return _context.abrupt("return", _this.$swal(data.msg || '該時間沒有資料'));
              case 21:
                _this.previewData = data.data;
                _this.downloadInfo = [factoryName, _this.selectedDate, _this.selectedTime];
                _context.next = 29;
                break;
              case 25:
                _context.prev = 25;
                _context.t0 = _context["catch"](11);
                // 攔截器對非 2xx 會 reject error.response.data，取其 msg 顯示
                _this.previewData = [];
                _this.$swal((_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || '查詢失敗');
              case 29:
                _context.prev = 29;
                _this.loadingData = false;
                return _context.finish(29);
              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[11, 25, 29, 32]]);
      }))();
    },
    downloadCsv: function downloadCsv() {
      if (!this.previewData.length) return;
      var toCell = function toCell(v) {
        return v === null || v === undefined ? '' : v;
      };
      // RA 值為 null 的列不匯出
      var rows = this.previewData.filter(function (row) {
        return row.ra !== null && row.ra !== undefined;
      }).map(function (row) {
        return [row.inv, row.pv, toCell(row.insulation), toCell(row.pvVoltage), toCell(row.pvCurrent), toCell(row.ra)].join(',');
      });
      var csvContent = [CSV_HEADER.join(',')].concat(_toConsumableArray(rows)).join('\r\n');

      // 加上 UTF-8 BOM 讓 Excel 正確辨識中文
      var blob = new Blob(["\uFEFF" + csvContent], {
        type: 'text/csv;charset=utf-8;'
      });
      var fileName = 'summary_for_monitoring.csv';
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }
  }),
  mounted: function mounted() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (_this2.factoryInfo.length) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return _this2.asyncInfo();
            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};